import React, { useState, useEffect } from 'react';
import {
    Link,
} from "react-router-dom";
import axios from 'axios';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';

function SubAdminDownloadCenter(props) {
    const [document_info, setDocument_info] = useState({
        selected_all: false,
        control_folder: false,
        control_file: false,
        step_back: 'download_center',
        current_path: 'download_center',
        doc_list: []
    });

    const [folder_text, setFolder_text] = useState("")
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const isBackDisabled = document_info.current_path === "documents";

    useEffect(() => {
        api_dcuments_browse('download_center')
        return () => {
            setDocument_info({
                selected_all: false,
                control_folder: false,
                control_file: false,
                step_back: 'download_center',
                current_path: 'download_center',
                doc_list: []
            });
        }
    }, []);

    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(confirmcode) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    async function api_dcuments_browse(current_path) {
        const formData = new FormData()
        formData.append('current_path', current_path)
        axios.post(process.env.REACT_APP_API_URL + "/proxy/supports/api/supports/downloadcenter/files/browse", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer LBV976sR1GpcM9YZUWPjCev7gs8hVO60pcCsUeyeyz1fxo7cXOEJKS12dDMjhJDz"
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
                if (response.data.data !== null && response.data.data !== undefined) {
                    setDocument_info(response.data.data)
                }
            })
            .catch((err) => {
                setFolder_text("")
                setDocument_info({
                    selected_all: false,
                    control_folder: false,
                    control_file: false,
                    step_back: 'download_center',
                    current_path: 'download_center',
                    doc_list: []
                });
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function api_click_folder(isdir, pathname) {
        if (isdir === true) {
            api_dcuments_browse(pathname)
        }
    }

    function open_pdf(timestamp, file_link) {
        let url = process.env.REACT_APP_API_URL + "/proxy/supports/api/supports/downloadcenter/files/reader?ts=" + timestamp + "&&filename=" + file_link
        window.open(url, "_blank")
    }


    function download_pdf(timestamp, file_link, file_name) {
        let url = process.env.REACT_APP_API_URL + "/proxy/supports/api/supports/downloadcenter/files/download?ts=" + timestamp + "&&filename=" + file_link
        const link = document.createElement("a");
        link.href = url
        link.download = file_name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    function get_file_icon(ext) {
        if (ext === ".pdf") {
            return 'mdi mdi-file-pdf-outline file-color-pdf  me-2'
        } else if (ext === ".xls" || ext === ".xlsx") {
            return 'mdi mdi-file-excel-outline file-color-excel  me-2'
        } else if (ext === ".doc" || ext === ".docx") {
            return 'mdi mdi-file-word-outline file-color-word  me-2'
        } else if (ext === ".ppt" || ext === ".pptx") {
            return 'mdi mdi-file-powerpoint-outline file-color-ppt  me-2'
        } else if (ext === ".csv") {
            return 'mdi mdi-file-delimited-outline file-color-csv  me-2'
        } else if (ext === ".txt") {
            return 'mdi mdi-file-outline file-color-txt  me-2'
        } else if (ext === ".dwg") {
            return 'mdi mdi-file-cad file-color-dwg  me-2'
        } else if (ext === ".jpg" || ext === ".jpeg" || ext === ".png" || ext === ".bmp") {
            return 'mdi mdi-file-image-outline file-color-image  me-2'
        } else if (ext === "folder") {
            return 'mdi mdi-folder file-color-folder me-2'
        } else if (ext === ".exe" || ext === ".msi") {
            return 'mdi mdi-file-cog file-color-unknown me-2'
        }
        return 'mdi mdi-file-outline file-color-unknown  me-2'
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-th-large"></i> Download Center</h4>
                                    <p className="mb-0">Downlaod all items available on server.</p>
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                <button className="btn btn-info btn-sm" type="button" onClick={() => { api_dcuments_browse(document_info.step_back) }} disabled={isBackDisabled}><i className="fa fa-arrow-left me-2"></i> Back</button>
                                <button className="btn btn-success btn-sm" type="button" onClick={() => { api_dcuments_browse(document_info.current_path) }} ><i className="fas fa-sync-alt me-2"></i> Refresh</button>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3 mb-1 mb-md-4">
                        <h5>Document Path : {document_info.current_path} ....... (found {document_info.doc_list.length} items)</h5>
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered text-nowrap" >
                                <thead>
                                    <tr className="admintable-header">
                                        <th>#</th>
                                        <th>Name</th>
                                        <th>Date Modify</th>
                                        <th className="text-center" style={{ width: "100px" }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {
                                        document_info.doc_list?.map((data, index) => (
                                            <tr key={data.file_link}>
                                                <td width={'50px'}>{index + 1}</td>
                                                <td><div className={data.is_dir ? 'file-items-browser file-cursor' : "file-items-browser"} onClick={() => { api_click_folder(data.is_dir, data.current_path + '/' + data.name) }}><i className={get_file_icon(data.extension)} style={{ fontSize: "16px" }}></i> {data.name} {data.detail}</div></td>
                                                <td width={'150px'}>{data.modify_time}</td>
                                                <td width={'150px'}>
                                                    {data.is_dir === true ?
                                                        <>
                                                            <Link className="btn btn-sm btn-hover btn-bordered" title="Open Directory" onClick={() => { api_dcuments_browse(data.current_path + '/' + data.name) }}><i className='fa fa-search'></i></Link>
                                                        </>
                                                        :
                                                        <>
                                                            {
                                                                data.extension === ".pdf" ?
                                                                    <Link className="btn btn-sm btn-hover btn-bordered me-1" title="View File" onClick={() => { open_pdf(data.timestamp, data.file_link) }}><i class="fa fa-search"></i></Link>
                                                                    :
                                                                    null
                                                            }
                                                            <Link className="btn btn-sm btn-hover btn-bordered" title="Download" onClick={() => { download_pdf(data.timestamp, data.file_link, data.name) }}><i className='fa fa-download'></i></Link>
                                                        </>
                                                    }
                                                </td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>

                        </div>
                    </div>

                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminDownloadCenter